import { OUT_OF_PAGE_TYPES } from '../constants/banner.js';

const BannerFromIframeToBannerType = {
    showFullscreen: OUT_OF_PAGE_TYPES.FULLSCREEN,
    fullSreenBannerHTML5: OUT_OF_PAGE_TYPES.FULLSCREEN,
    mobileBanner: OUT_OF_PAGE_TYPES.MOBILE_BOTTOM,
};

export { BannerFromIframeToBannerType };
//# sourceMappingURL=index.js.map
